import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ContratElementVariableDto } from "../../../dto/GenApi.iNotPaie.Dto/ContratElementVariableDto";

@Component
export default class ModalRecapVariables extends Vue {
	public contrat?: ContratElementVariableDto = undefined;
	public libelleContrat?: string = "";

	public annuler(): void {
		$("#modalRecapVariables").modal("hide");
	}

	public getDetails(contrat: ContratElementVariableDto): void {
    	this.contrat = contrat;
		this.libelleContrat = contrat.FullName;
		this.$forceUpdate();
	}
}




// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/modalRecapVariables/modalRecapVariables.ts